export function setupProductRecommend(context = document) {
    const els = context.querySelectorAll('.js-product-recommend')

    if (els.length) {
        import('./product-recommend')
            .then((m) => m.ProductRecommend)
            .then((ProductRecommend) => {
                Array.from(els).map(ProductRecommend)
            })
    }
}
